module.exports = __webpack_public_path__ + "img/ico-diabetes-90-x-90.b59175fd.svg";